/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createReducer } from 'state/utils';

export default createReducer(null, {
    [actions.SET_PRIMARY_PAYMENT_SOURCE_ID]: (state, action) => {
        return get(action, 'payload.primaryPaymentSourceId', null);
    },
    [actions.CURRENT_USER_CHARGEBEE_CUSTOMER_RECEIVE]: (state, action) => {
        return get(action, 'payload.customer.primary_payment_source_id', null);
    },
});
